import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import SelectInput from "../../../../components/inputs/select";
import TextInput from "../../../../components/inputs/text";
import NumberInput from "../../../../components/inputs/number";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import { IndexHook, BANCOS, LAYOUTS, EMISSORES, AMBIENTES } from "./hooks";

const Form = ({ isOpenModalRegister, ident, idTable, selectedData, setSelectData, fetchID, reloadData, insert }) => {
	const {
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,
		loading,
		errors,
		isSubmitting,
		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<form className="form" onSubmit={handleSubmit(handleOnSubmit)}>
					<main>
						<div className="row">
							<SelectInput
								label="Banco"
								id="banco"
								labelSelect="nome"
								control={control}
								data={BANCOS}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
								className="col-12 col-sm-6"
							/>

							<TextInput
								label="Descrição"
								id="descricao"
								placeholder="Ex.: BB - Cobrança Simples"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-6"
							/>

							<TextInput
								label="Razão Social do Beneficiário"
								id="cedente_nome"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-6"
							/>

							<TextInput
								label="CNPJ do Beneficiário"
								id="cedente_cnpj"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-6"
							/>

							{/* Agencia e conta como texto: zero a esquerda importa. */}
							<TextInput
								label="Agência"
								id="agencia"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<TextInput
								label="Dígito da Agência"
								id="agencia_dv"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<TextInput
								label="Conta Corrente"
								id="conta"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<TextInput
								label="Dígito da Conta"
								id="conta_dv"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							<TextInput
								label="Número do Convênio"
								id="convenio"
								placeholder="Ex.: 3675478"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<TextInput
								label="Código do Beneficiário"
								id="codigo_cedente"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<TextInput
								label="Carteira"
								id="carteira"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<TextInput
								label="Variação / Modalidade"
								id="modalidade"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							{/* Sigla, nao codigo: DM, NP, DS, RC... */}
							<TextInput
								label="Espécie do Documento"
								id="especie_doc"
								placeholder="DM"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							<SelectInput
								label="Layout CNAB"
								id="layout"
								labelSelect="nome"
								control={control}
								data={LAYOUTS}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							<SelectInput
								label="Quem emite o boleto"
								id="respon_emissao"
								labelSelect="nome"
								control={control}
								data={EMISSORES}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							<SelectInput
								label="Ambiente"
								id="ambiente"
								labelSelect="nome"
								control={control}
								data={AMBIENTES}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							{/* Faixa autorizada pelo banco. Emitir fora dela
							    faz o registro ser recusado. */}
							<NumberInput
								label="Nosso Número inicial (só o sequencial)"
								name="nosso_numero_ini"
								control={control}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>
							<NumberInput
								label="Nosso Número final"
								name="nosso_numero_fim"
								control={control}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-3"
							/>

							<div className={`check-box col-12 col-sm-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_boleto_config"
										type="checkbox"
										{...register("ativo")}
										autoComplete="off"
									/>
									<label htmlFor="ativo_boleto_config">
										<span className="text-lg">Convênio ativo</span>
									</label>
								</div>
							</div>
						</div>
					</main>
					<footer>
						<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>
				</form>
			)}
		</>
	);
};

export default Form;
